module.exports = __webpack_public_path__ + "img/activepracticeinterview.de65e93d.svg";